//------------
// has delays
//------------
export default function hasDelays(combatants, cur_action) {
  // console.log("----------------------");
  // console.log("IN hasDelays cur action = " + cur_action + " combatants = " + combatants.length);
  let ca_name = "ca_name" + cur_action;
  var delay_cnt = 0;
  //------------------------------------------------------------------
  // check for any delay actions across all combatants for cur action
  //------------------------------------------------------------------
  for (let i = 0; i < combatants.length; i++) {
    if (combatants[i][ca_name] == "delay") {
      delay_cnt++;
    }
  }
  return delay_cnt;
}
